import startApproval from './start-approval.vue';
var Plugin = {
  install: function install(Vue) {
    Vue.component('start-approval', startApproval);
  }
};
export { startApproval };
export default Plugin;


//////////////////
// WEBPACK FOOTER
// ./src/component/start-approval/index.js
// module id = 3
// module chunks = 0